export const createClientWithConsent = (
    { createActions, consentsActions },
    accessToken,
    onCreateCallback = undefined,
    onSendConsentCallback = undefined,
    onError = undefined
) => {
    createActions.createClient(accessToken, (valid, userId) => {
        if (valid) {
            onCreateCallback?.(userId);
            consentsActions.sendFiocTgssConsent(accessToken, onSendConsentCallback || (() => {}));
        } else {
            onError?.();
        }
    });
};
